import script from "./ItemName.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemName.vue?vue&type=script&setup=true&lang=js"

import "./ItemName.vue?vue&type=style&index=0&id=3c5802d5&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5802d5"]])

export default __exports__